import { DateRangeSchema } from '@/utils';
import { z } from 'zod';
import { COST_CODE_LENGTH, NAME_MAX_LENGTH } from '../utils';
import { getCodeMaxValue } from '../utils/get-code-max-value'; // NOTE: Barrels are not used here to avoid circular dependencies in the test environment.

const CostBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  code: z.number().int().min(1).max(getCodeMaxValue(COST_CODE_LENGTH)),
  name: z.string().min(1),
  startYear: z.number().int().nullable(),
  endYear: z.number().int().nullable(),
});

export const CostsModel = CostBaseModel.array();

export const CostFormSchema = CostBaseModel.pick({
  code: true,
}).extend({
  name: CostBaseModel.shape.name.max(NAME_MAX_LENGTH),
  period: DateRangeSchema.nullish(),
});
